import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { offer } from "../data/salesCopy";
import { useCountdown } from "../hooks/useCountdown";
export function StickyCta() {
  const [visible, setVisible] = useState(false);
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const lowest = offer.plans[0].price;
  useEffect(() => {
    const onScroll = () => {
      const pastHero = window.scrollY > 650;
      const blockers = document.querySelectorAll<HTMLElement>("[data-hide-sticky]");
      const overlapping = Array.from(blockers).some(el => {
        const r = el.getBoundingClientRect();
        return r.top < window.innerHeight && r.bottom > 0;
      });
      setVisible(pastHero && !overlapping);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  const pad = (n: number) => String(n).padStart(2, "0");
  return <AnimatePresence data-id="element-262" data-mp="75cjwo6djf8x">
      {visible && <motion.div initial={{
      y: "100%"
    }} animate={{
      y: 0
    }} exit={{
      y: "100%"
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-line bg-card px-4 py-2.5 shadow-[0_-8px_24px_rgba(30,42,36,0.08)] md:hidden" data-id="element-263" data-mp="76f7am4hmzk3">
          <div className="flex items-center gap-3" data-id="element-264" data-mp="pwdez14diqn7">
            <div className="min-w-0 flex-1" data-id="element-265" data-mp="pv2g9fpsc92y">
              <p className="text-[11px] text-muted" data-id="element-266" data-mp="lus75u6p52jv">
                Desde <span className="font-display text-base font-extrabold text-ink" data-id="element-267" data-mp="lu8mw6tkq22o">{lowest}</span>
              </p>
              <p className="text-[11px] font-semibold tabular-nums text-coral" data-id="element-268" data-mp="zsgtl6gewhr1">
                Termina en {pad(hours)}:{pad(minutes)}:{pad(seconds)}
              </p>
            </div>
            <a href="#ofertas" className="shrink-0 rounded-xl bg-coral px-4 py-3 text-sm font-extrabold text-white transition-colors duration-150 ease-out active:bg-[#B9452F]" data-id="element-269" data-mp="31mg1dhubsgyz">
              VER OFERTAS
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}